export default function IconA2() {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1215_7476)">
                <path
                    d="M30.9375 6.75H5.0625C4.13052 6.75 3.375 7.50552 3.375 8.4375V24.1875C3.375 25.1195 4.13052 25.875 5.0625 25.875H30.9375C31.8695 25.875 32.625 25.1195 32.625 24.1875V8.4375C32.625 7.50552 31.8695 6.75 30.9375 6.75Z"
                    stroke="#707070"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M3.375 21.375H32.625" stroke="#707070" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14.625 29.25H21.375" stroke="#707070" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M18 29.25L18 25.875" stroke="#707070" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1215_7476">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
